// extracted by mini-css-extract-plugin
export default {"list":"WebinarsList_list__7QrOU","mobile":"WebinarsList_mobile__5vyp1","image":"WebinarsList_image__Tj2gC"};